import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const API = process.env.REACT_APP_BACKEND_URL;

let cachedSettings = null;

export default function PublicLogo({ size = 'header', className = '' }) {
  const [settings, setSettings] = useState(cachedSettings);

  useEffect(() => {
    if (cachedSettings) return;
    fetch(`${API}/api/app-settings/public`)
      .then(r => r.json())
      .then(data => { cachedSettings = data; setSettings(data); })
      .catch(() => {});
  }, []);

  const logo = settings?.app_logo;
  const shape = settings?.logo_shape || 'square';
  const headerH = settings?.logo_header_height || 32;
  const shapeClass = shape === 'circle' ? 'rounded-full' : shape === 'rounded' ? 'rounded-lg' : '';

  if (size === 'header') {
    return (
      <Link to="/login" className={`flex items-center gap-2 ${className}`}>
        {logo ? (
          <img src={`${API}/api/uploads/${logo}`} alt="Thrive" style={{ maxHeight: `${headerH}px` }} className={`object-contain ${shapeClass}`} />
        ) : (
          <span className="text-xl font-black text-amber-600">Thrive</span>
        )}
        {!logo && <span className="text-xs text-stone-400 hidden sm:inline">Beekeeping</span>}
      </Link>
    );
  }

  // Hero size — for landing sections
  const loginH = settings?.logo_login_height || 80;
  return (
    <img
      src={logo ? `${API}/api/uploads/${logo}` : '/thrive-logo.png'}
      alt="Thrive Beekeeping"
      style={{ maxHeight: `${loginH}px` }}
      className={`object-contain ${shapeClass} ${className}`}
    />
  );
}
